import { render, staticRenderFns } from "./ItemRecommendation.vue?vue&type=template&id=88b1a4ea&"
import script from "./ItemRecommendation.vue?vue&type=script&lang=js&"
export * from "./ItemRecommendation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports